import { useSyncExternalStore } from "react";
import { useAuth } from "src/domains/shared/hooks/user";
import { hasStoredLogin } from "src/domains/shared/utils/exclusiveLogin/loginClaimPending";
import { LOGIN_ROUTE } from "src/domains/shared/utils/exclusiveLogin/loginRoutes";
import { SITE_APP_START_HREF } from "../SiteShell/SiteHeader/siteNav";

/** 다른 탭의 로그인·로그아웃만 받는다 — 이 탭의 변화는 `useAuth` 상태가 맡는다 */
const subscribeStoredLogin = (onChange: () => void) => {
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
};

/** 서버 HTML 에는 저장소가 없다 — 하이드레이션을 서버 HTML(로그인 화면)과 맞춘 뒤 저장된 로그인으로 다시 그린다 */
const noStoredLoginOnServer = () => false;

/**
 * 「시작하기」 가 가는 곳 — 로그인했으면 프로젝트 목록, 아니면 로그인 화면. 로그인 확인이 끝나기 전에는 머리말 계정
 * 버튼과 같은 저장된 로그인 판정을 따른다(marketing-site-shell 「본문 시작하기 버튼은 로그인 상태를 따른다」).
 */
export function useStartHref(): string {
  const { currentUser, isLoading } = useAuth();
  const storedLogin = useSyncExternalStore(
    subscribeStoredLogin,
    hasStoredLogin,
    noStoredLoginOnServer
  );
  const signedIn = Boolean(currentUser) || (isLoading && storedLogin);
  return signedIn ? SITE_APP_START_HREF : LOGIN_ROUTE;
}
